

import React, { useState } from 'react';
import TransactionTable from './PayableTable';
import TransactionForm from './PayableForm';

const Transactions = () => {
  const [showForm, setShowForm] = useState(false);
  const [editingTransaction, setEditingTransaction] = useState(null);

  return (
    <>
      {showForm ? (
        <TransactionForm 
          transactionToEdit={editingTransaction}
          onSuccess={() => {
            setShowForm(false);
            setEditingTransaction(null);
          }}
          onCancel={() => {
            setShowForm(false);
            setEditingTransaction(null);
          }}
        />
      ) : (
        <TransactionTable 
          onAddTransaction={() => setShowForm(true)}
          onEditTransaction={(transaction) => {
            setEditingTransaction(transaction);
            setShowForm(true);
          }}
        />
      )}
    </>
  );
};

export default Transactions;